export interface LatestKnownUserData {
    UserKey: string;
    UserName: string;
    FirstName: string;
    LastName: string;
    WorkgroupKey?: number;
}
